export default (theme) => ({
  root: {
    position: "relative",
    padding: "0px 20px 20px 20px",
  },
});
